// PLACEHOLDER — automatic MIC mail bucket creation.
//
// The real MIC (Mediant Investor Communications) API integration is pending —
// this stub simulates that call so the automatic-creation flow can be
// demoed end to end: Material Type, Supplier, Lit Code, Quantity, Location,
// and Mailing Method are read off the confirmed Regulatory match and "sent"
// to MIC instead of a clerk keying them in by hand.
//
// When the real MIC API lands, replace the body with the actual call (e.g.
// POST to MIC's mail-bucket endpoint). The call site in AcePage already
// builds the full payload, so only this function needs to change.

export interface MicMailBucketPayload {
  materialType: string;
  supplier: string;
  litCode: string;
  quantity: string;
  location: string;
  mailingMethod: string;
  jobNumbers: string[];
}

export interface MicMailBucketResult {
  bucketId: string;
  status: 'created';
  fields: MicMailBucketPayload;
}

export async function createMicMailBucket(payload: MicMailBucketPayload): Promise<MicMailBucketResult> {
  // No-op placeholder. Intentionally does not hit the network.
  const bucketId = `MIC-${Math.floor(1000000 + Math.random() * 9000000)}`;
  // eslint-disable-next-line no-console
  console.info('[micService] placeholder mail-bucket creation (MIC not yet integrated):', bucketId, payload);
  return { bucketId, status: 'created', fields: payload };
}

// Chronological-note text for the receipt's note_log, so the auto-creation is
// visible in the receipt history the same way any other system action is.
export function formatMicBucketNote({ bucketId, fields }: MicMailBucketResult): string {
  return (
    `Mail bucket auto-created in MIC — Bucket #${bucketId}\n` +
    `Material Type: ${fields.materialType || '—'} · Supplier: ${fields.supplier || '—'} · Lit Code: ${fields.litCode || '—'}\n` +
    `Quantity: ${fields.quantity || '—'} · Location: ${fields.location || '—'} · Mailing Method: ${fields.mailingMethod}`
  );
}
